module.exports = __webpack_public_path__ + "static/media/nachos-cabreras.474e2de6.jpg";